import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  deleteObj,
  exportExcel,
  deleteByAnalyzeDatetimeRange,
  anlyze,
} from '@/api/gddlysjgvehicleanalyzereportserv'

export default {
  state: {
    state_GdDlysjgVehicleAnalyzeReport_GetAllResult: null,
    state_GdDlysjgVehicleAnalyzeReport_SearchByNameResult: null,
    state_GdDlysjgVehicleAnalyzeReport_GetPageResult: null,
    state_GdDlysjgVehicleAnalyzeReport_GetDetailResult: null,
    state_GdDlysjgVehicleAnalyzeReport_DeleteObjResult: null,
    state_GdDlysjgVehicleAnalyzeReport_ExportExcelResult: null,
    state_GdDlysjgVehicleAnalyzeReport_DeleteByAnalyzeDatetimeRangeResult: null,
    state_GdDlysjgVehicleAnalyzeReport_AnlyzeResult: null,
  },
  mutations: {
    SET_GDDLYSJGVEHICLEANALYZEREPORT_GETALL_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleAnalyzeReport_GetAllResult = rst;
    },
    SET_GDDLYSJGVEHICLEANALYZEREPORT_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleAnalyzeReport_SearchByNameResult = rst;
    },
    SET_GDDLYSJGVEHICLEANALYZEREPORT_GETPAGE_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleAnalyzeReport_GetPageResult = rst;
    },
    SET_GDDLYSJGVEHICLEANALYZEREPORT_GETDETAIL_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleAnalyzeReport_GetDetailResult = rst;
    },
    SET_GDDLYSJGVEHICLEANALYZEREPORT_DELETEOBJ_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleAnalyzeReport_DeleteObjResult = rst;
    },
    SET_GDDLYSJGVEHICLEANALYZEREPORT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleAnalyzeReport_ExportExcelResult = rst;
    },
    SET_GDDLYSJGVEHICLEANALYZEREPORT_DELETEBYANALYZEDATETIMERANGE_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleAnalyzeReport_DeleteByAnalyzeDatetimeRangeResult = rst;
    },
    SET_GDDLYSJGVEHICLEANALYZEREPORT_ANLYZE_RESULT: (state, rst) => {
      state.state_GdDlysjgVehicleAnalyzeReport_AnlyzeResult = rst;
    },
  },
  actions: {
    GdDlysjgVehicleAnalyzeReportServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleAnalyzeReportServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleAnalyzeReportServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleAnalyzeReportServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleAnalyzeReportServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleAnalyzeReportServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleAnalyzeReportServ_DeleteByAnalyzeDatetimeRange({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteByAnalyzeDatetimeRange(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_DELETEBYANALYZEDATETIMERANGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_DELETEBYANALYZEDATETIMERANGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgVehicleAnalyzeReportServ_Anlyze({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        anlyze(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_ANLYZE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGVEHICLEANALYZEREPORT_ANLYZE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_GdDlysjgVehicleAnalyzeReport_GetAllResult: state => {
      return state.state_GdDlysjgVehicleAnalyzeReport_GetAllResult;
    },
    get_GdDlysjgVehicleAnalyzeReport_SearchByNameResult: state => {
      return state.state_GdDlysjgVehicleAnalyzeReport_SearchByNameResult;
    },
    get_GdDlysjgVehicleAnalyzeReport_GetPageResult: state => {
      return state.state_GdDlysjgVehicleAnalyzeReport_GetPageResult;
    },
    get_GdDlysjgVehicleAnalyzeReport_GetDetailResult: state => {
      return state.state_GdDlysjgVehicleAnalyzeReport_GetDetailResult;
    },
    get_GdDlysjgVehicleAnalyzeReport_DeleteObjResult: state => {
      return state.state_GdDlysjgVehicleAnalyzeReport_DeleteObjResult;
    },
    get_GdDlysjgVehicleAnalyzeReport_ExportExcelResult: state => {
      return state.state_GdDlysjgVehicleAnalyzeReport_ExportExcelResult;
    },
    get_GdDlysjgVehicleAnalyzeReport_DeleteByAnalyzeDatetimeRangeResult: state => {
      return state.state_GdDlysjgVehicleAnalyzeReport_DeleteByAnalyzeDatetimeRangeResult;
    },
    get_GdDlysjgVehicleAnalyzeReport_AnlyzeResult: state => {
      return state.state_GdDlysjgVehicleAnalyzeReport_AnlyzeResult;
    },
  }
}